
<div class="w-full h-full max-w-1440 grid grid-cols-5">
  <div class="border-r border-l">
    <Links :activeDropdown="activeDropdown" :dropdownLinks="dropdownLinks" />
  </div>
  <div class="border-r">
    <Links :activeDropdown="'company'" :dropdownLinks="dropdownLinks" />
  </div>
  <div class="col-span-3 border-r">
    <DropdownFindInventory v-if="activeDropdown == 'solutions'" />
    <DropdownFeaturedGuides v-if="activeDropdown == 'guides'" />
    <DropdownResources v-if="activeDropdown == 'resources'" />
  </div>
</div>
